<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>提高寫作品質和讓<br />編輯工作更順暢</h1>
                        <p>使您的團隊能夠更一致地寫作、更快地發佈，並且提升客戶體驗。在不犧牲寫作品質、一致性、品牌形象和寫作風格的的前提下減少寫作時間和降低成本。
                        </p>
                        <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">獲取報價</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/language-services-publishing-and-media.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>以行業為中心的解決方案</h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>編輯和校對公司</li>
                            <li>媒體和出版社</li>
                            <li>博主和部落格</li>
                            <li>翻譯服務公司</li>
                            <li>預出版工作室</li>
                            <li>行銷機構</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>深受全球領導者信賴</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/alternet.png" alt="">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarperCollinsPublishers.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/scholastic.png" alt="">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/RightlyWritten.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/sanchini.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/technica.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/CapstoneWriting.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/evolution_editing.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>幫助您的團隊更好寫作的企業功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka可以幫助您的團隊高效創建關鍵文檔，同時確保寫作品質並符合科學寫作習慣。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/BulkEditingOperations.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>批量編輯操作</h3>
                                    <p>上傳您的微軟Word文檔，Trinka能夠在幾分鐘內對其進行編輯。您只需下載編輯過的文件，然後查看所有更改即可完成工作。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>上下文拼寫檢查和字典 </h3>
                                    <p>Trinka的內置拼寫檢查器清楚知道“from”和“form”之間的區別，也知道數百萬個技術詞彙。每個團隊成員都可以創建個人詞典或使用同一個詞典來輕鬆保持您相關品牌的所有通信的一致性。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/WordCountreductions.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>字數縮減</h3>
                                    <p>Trinka可幫助您簡明扼要地表達觀點，讓您的資訊產生正確的影響力。您的團隊在寫作的同時也在學習！</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Suggestionsthatmatchyourtone.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>符合您寫作語氣的建議</h3>
                                    <p>無論您寫休閒文章還是正式文檔，Trinka的人工智慧都會提供正確的建議。對於研究性質的文檔，您甚至可以設置研究類型，包括原創研究、評論文章和案例報告。
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="Easy User Management" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>簡易的用戶管理</h3>
                                    <p>您的團隊帳戶允許您輕鬆添加或刪除成員。即時管理信用和使用限制。透過Trinka的細化控制，訪問管理變得簡單而安全--無論是您的員工還是外包的接案人員。</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="plag check icon" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>抄襲檢測 </h3>
                                    <p>先進的文本相似性檢測演算法，高品質的抄襲檢查， iThenticate技術支援，最大的付費出版物資料庫。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="Comprehensive Analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>綜合分析</h3>
                                    <p>瞭解您的團隊如何使用Trinka，或透過豐富的分析深入瞭解每個用戶的活動，以制定有效的決策。
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>專門的支持</h3>
                                    <p>指定一名專門的成經驗豐富的經理來幫助您的團隊充分利用Trinka，包括詳細的產品熟悉過程、説明文檔和視頻演練。
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>為所有用例提供幫助</h2>
                    <div class="HeadingSubLine"></div>
                    <p>借助針對特定行業和角色量身定制的用例，發現Trinka的強大功能。</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>內容編輯的強大協助</h4>
                                <p>Trinka糾正語法和高級機械性問題，讓您的編輯專家可以專注于語義和交付，這樣可以提高輸出品質並有助於簡化工作流程。</p>
                                <ul>
                                    <li>縮短專案的時程</li>
                                    <li>提高編輯品質</li>
                                    <li>縮短發佈時間</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>對於行銷團隊</h4>
                                <p>借助Trinka的精確建議，您的團隊能夠創建更好的客戶電子郵件、行銷資料、通訊、報告，以及宣傳等。</p>
                                <ul>
                                    <li>避免客戶溝通中出現令人尷尬的錯誤</li>
                                    <li>輕鬆保持品牌和重點</li>
                                    <li>縮短內容的交付時間</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>關於編輯品質評估</h4>
                                <p>Trinka的寫作評估人工智慧可以為您提供有用的見解，包括可自訂的寫作分數和按類別劃分的寫作錯誤解析。</p>
                                <ul>
                                    <li>關於寫作品質的定量剖析</li>
                                    <li>協助編輯招聘</li>
                                    <li>帶有解釋和提示的學習機會</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>翻譯後自動語法檢查</h4>
                                <p>翻譯團隊可以使用Trinka透過精確的語法更正來改進他們的英語翻譯，並獲得高品質的分析。</p>
                                <ul>
                                    <li>上下文拼寫檢查</li>
                                    <li>技術用語和句子結構改進</li>
                                    <li>用於高通量工作流程的自動化文件編輯</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>與您的專屬軟體和工作流程集成</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>Trinka的簡單集成讓您的團隊在現有的軟體中享受所有的好處，使有效的寫作變得富有成效和無縫。</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>JavaScript</h3>

                    <p>
                        只需將一個很小的JavaScript(JS)代碼片段插入到您的瀏覽器或任何應用程式，即可為所有團隊成員啟用Trinka功能。
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>應用程式介面（API）</h3>
                    <p>
                        Trinka強大的應用程式介面（API）讓它可以直接集成到您現有的應用程式中。Trinka採用簡單的應用程式介面架構，集成很容易。</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>內部部署</h3>
                    <p>Trinka將託管在您的企業基礎架構（本地或雲伺服器）上，確保您團隊有效寫作的同時保持最大程度的機密性。
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>雲端編輯器</h3>


                    <p>
                        透過安全的基於Web的應用程式，隨時隨地發揮Trinka的全部潛力。
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>微軟Word外掛程式</h3>
                    <p>
                        透過在微軟Word中提供寫作建議來提高團隊的工作效率。
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>瀏覽器外掛程式</h3>
                    <p>
                        外掛程式適用於所有受歡迎的瀏覽器，為您在任何網站提供即時的寫作幫助。
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>適合您的個性化定價</h2>
                </div>
                <p>Trinka提供基於使用者數量或使用情況的靈活定價，以滿足用戶的獨特需求。
                    <br>您可以即時切換用戶並應用使用限制，而無需額外費用。
                    <br>我們將與您合作，透過採購訂單或者發票輕鬆定制合同和單一付款選項。</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">Get a Quote</a> -->

                    <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">獲取報價</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>安全、可靠、值得信賴</h3>
                        <p>Trinka將資料安全和隱私放在首位。您的所有資料都經過高度加密並安全存儲，沒有其他人能夠訪問您的資料。我們提供獨有的方案，一旦送給您寫作建議，我們就會完全刪除保存的資料。
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>關於人工智慧</h3>
                        <p>Trinka使用最新的機器學習(ML)和自然語言處理(NLP)技術來識別語法錯誤並提出語言改進建議。Trinka是數百萬篇優秀論文和文章的訓練成果。它涵蓋了1300多個學科領域，包括醫學、生命科學、生物學、物理科學、工程、人文、商業和藝術，能為您提供最相關的建議。</p>
                        <p>Trinka由語言學家、醫學編輯、資料科學家和工程師組成的團隊開發而成，他們深切希望透過無障礙溝通創造未來。
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>使用Trinka改變您的業務溝通方式</p>
    <button (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">請求報價</button>
</div>



<div class="modal custom_modal_popup enterprisePopup" id="EnterPriseContactPopup">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="closed_icons">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="contactPopupHeading">
                                <h2>企業客戶諮詢</h2>
                                <p *ngIf="formSection">誰需要我們的服務？</p>
                            </div>
                        </div>
                        <div class="inquiryTypeSection">
                            <ul class="nav nav-tabs" role="tablist" *ngIf="formSection">
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#IndividualType" role="tab">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                            <defs>
                                                <style>
                                                    .cls-1 {
                                                        fill: none;
                                                        stroke: #783694;
                                                        stroke-linecap: round;
                                                        stroke-linejoin: round;
                                                        stroke-width: 2px;
                                                    }
                                                </style>
                                            </defs>
                                            <title>TrinkaIcons-new</title>
                                            <g id="Individual">
                                                <path class="cls-1" d="M44.83,45.13V39.82a4.65,4.65,0,0,0-1.7-3.6,62.85,62.85,0,0,0-10.89-7V22.5a4.4,4.4,0,0,0,1.56-3.36V11.39A7.9,7.9,0,0,0,25.91,3.5H24.24a7.9,7.9,0,0,0-7.89,7.89v7.75a4.32,4.32,0,0,0,1.54,3.36h0v6.68A62.22,62.22,0,0,0,7,36.22a4.62,4.62,0,0,0-1.7,3.6v5.31"
                                                />
                                            </g>
                                        </svg>
                                        <div class="text-left">
                                            <h3>個人用戶</h3>
                                            <span>（單一使用者）</span>
                                        </div>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#OrganizationType" role="tab">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                            <defs>
                                                <style>
                                                    .cls-1 {
                                                        fill: none;
                                                        stroke: #783694;
                                                        stroke-linecap: round;
                                                        stroke-linejoin: round;
                                                        stroke-width: 2px;
                                                    }
                                                </style>
                                            </defs>
                                            <title>TrinkaIcons-new</title>
                                            <g id="Organization">
                                                <path class="cls-1" d="M42.87,45.13V40.06a4.45,4.45,0,0,0-1.62-3.44,60,60,0,0,0-10.41-6.72V23.51a4.2,4.2,0,0,0,1.49-3.21V12.89a7.55,7.55,0,0,0-7.54-7.54H23.19a7.55,7.55,0,0,0-7.54,7.54V20.3a4.13,4.13,0,0,0,1.47,3.21h0v6.38A59.44,59.44,0,0,0,6.71,36.62a4.42,4.42,0,0,0-1.62,3.44v5.07"
                                                />
                                                <path class="cls-1" d="M14.34,30.75a24.56,24.56,0,0,0-3.32-2V26.18a1.66,1.66,0,0,0,.59-1.27V22a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v2.93a1.63,1.63,0,0,0,.58,1.27h0v2.53a23.54,23.54,0,0,0-4.12,2.66,1.75,1.75,0,0,0-.64,1.36v2"
                                                />
                                                <path class="cls-1" d="M34.29,30.75a24.56,24.56,0,0,1,3.32-2V26.18A1.66,1.66,0,0,1,37,24.91V22a3,3,0,0,1,3-3h.63a3,3,0,0,1,3,3v2.93A1.63,1.63,0,0,1,43,26.18h0v2.53a23.54,23.54,0,0,1,4.12,2.66,1.75,1.75,0,0,1,.64,1.36v2"
                                                />
                                            </g>
                                        </svg>
                                        <div class="text-left">
                                            <h3>企業或單位</h3>
                                            <span>（多個用戶）</span>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane" id="IndividualType" role="tabpanel" *ngIf="formSection">
                                    <div class="IndividualTypeSection">
                                        <p>Trinka對於個人用戶是免費的，您只需註冊您的電子郵箱地址即可。</p>
                                        <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊</a>
                                    </div>
                                </div>
                                <div class="tab-pane" id="OrganizationType" role="tabpanel" *ngIf="formSection">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="contact_us_form">
                                                <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                                    <h2>請在下面提出您的要求，我們的團隊將及時回復。</h2>
                                                    <div class="row">
                                                        <div class="col-md-6 rightPaddingRemove">
                                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                                <mat-form-field appearance="outline">
                                                                    <mat-label>業務性質*</mat-label>
                                                                    <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 leftPaddingRemove">
                                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                                <mat-form-field appearance="outline">
                                                                    <mat-label>單位名稱*</mat-label>
                                                                    <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="textbox_content form-group textareaBox" [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                                <label for="">請告訴我們您的要求</label>
                                                                <textarea formControlName="contactFormMessage" class="form-control" placeholder="例如。大約的用戶數，每個用戶的每月處理字數，所需的自訂設置等。"></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 rightPaddingRemove">
                                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                                <mat-form-field appearance="outline">
                                                                    <mat-label>您的姓名*</mat-label>
                                                                    <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 leftPaddingRemove">
                                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                                <mat-form-field appearance="outline">
                                                                    <mat-label>指定*</mat-label>
                                                                    <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 rightPaddingRemove">
                                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                                <mat-form-field appearance="outline">
                                                                    <mat-label>電子郵件*</mat-label>
                                                                    <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 leftPaddingRemove">
                                                            <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                                <mat-form-field appearance="outline">
                                                                    <mat-label>聯絡電話（包括國際代碼）</mat-label>
                                                                    <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                    <div class="form-group text-center">
                                                        <button type="submit">送出</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="thank_section contact_us_form" *ngIf="thankSection">
                                    <div class="form-group">
                                        <h2>感謝您！</h2>
                                        <p>我們會儘快和您聯絡。</p>
                                        <!-- <button data-dismiss="modal">Close</button> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>